import { Input } from "@progress/kendo-react-inputs";

export const PaddingProperty = {
  propertyName: "padding",
  propertyDisplay: "Padding",
  propertyType: "number",
  propertyCategory: "Style",
  renderer: function ({ handlePropertyChange, currentPropertyValues }) {
    return (
      <div
        className="align-rows"
        style={{ marginLeft: 0, paddingLeft: 20 }}
      >
        <div className="align-columns">
          <div>
            <Input
              label="top"
              type="number"
              name={"paddingTop"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "paddingTop", propValue: e.target.value });
              }}
              defaultValue={currentPropertyValues?.IsTab ? "" : currentPropertyValues?.paddingTop || ""}
            />
            <Input
              label="left"
              type="number"
              name={"paddingLeft"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "paddingLeft", propValue: e.target.value });
              }}
              defaultValue={currentPropertyValues?.IsTab ? "" : currentPropertyValues?.paddingLeft || ""}
            />
          </div>
          <div>
            <Input
              label="bottom"
              type="number"
              name={"paddingBottom"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "paddingBottom", propValue: e.target.value });
              }}
              defaultValue={currentPropertyValues?.IsTab ? "" : currentPropertyValues?.paddingBottom || ""}
            />
            <Input
              label="right"
              type="number"
              name={"paddingRight"}
              disabled={currentPropertyValues?.IsTab}
              onBlur={(e) => {
                handlePropertyChange({ propName: "paddingRight", propValue: e.target.value });
              }}
              defaultValue={currentPropertyValues?.IsTab ? "" : currentPropertyValues?.paddingRight || ""}
            />
          </div>
        </div>
      </div>
    );
  },
};
